// Why this indirect usage of window.location.assign?
// Because jsdom doesn't let us spy on or overwrite window.location,
// but we want to be able to test things that would call it.
const windowLocationAssign = (
  ...args: Parameters<typeof window.location.assign>
) => window.location.assign(...args)

export default windowLocationAssign
